const styles = {
  charts: {
    padding: '3em 0 !important',
    margin: '0 auto 2.25rem !important',
  },
  labelSeries: {
    stroke: '#fffdfd63',
    transform: 'translate(2.5em, -1.5em)',
    fontSize: '.9rem',
  },
  legend: {
    textAlign: 'center !important',
  },
};

export default styles;
